import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "./data";

export const CtaSection = ({
    testIdPrefix = "midcta",
    title = "Book Your Bridal Makeup Now",
    subtitle = "One message is all it takes to lock your wedding date with Chennai's trusted bridal makeup artist.",
    dark = false,
}) => (
    <section
        data-testid={`${testIdPrefix}-section`}
        className={`py-24 ${dark ? "bg-[#2C2A29]" : "bg-[#FDFBF7]"}`}
    >
        <div className="mx-auto max-w-3xl px-5 text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">
                Reserve your date
            </p>
            <h2
                className={`mt-3 font-serif text-4xl tracking-tight sm:text-5xl ${dark ? "text-white" : "text-[#2C2A29]"}`}
            >
                {title}
            </h2>
            <p className={`mt-5 text-base leading-relaxed ${dark ? "text-white/70" : "text-[#5A5652]"}`}>
                {subtitle}
            </p>
            <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
                <a
                    href={PHONE_TEL}
                    data-testid={`${testIdPrefix}-call-button`}
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-[#D4AF37] px-10 py-4 text-base font-extrabold text-[#2C2A29] shadow-xl transition-transform duration-200 hover:-translate-y-1"
                >
                    <Phone className="h-5 w-5" />
                    Call Now
                </a>
                <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`${testIdPrefix}-whatsapp-button`}
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-10 py-4 text-base font-extrabold text-white shadow-xl transition-transform duration-200 hover:-translate-y-1"
                >
                    <MessageCircle className="h-5 w-5" />
                    WhatsApp Now
                </a>
            </div>
        </div>
    </section>
);
